import { Button, CircularProgress, FormControlLabel, Grid, makeStyles, Radio, RadioGroup } from "@material-ui/core";
import { AddCircleOutline } from "@material-ui/icons";
import axios from 'axios';
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addProject } from "../../../redux/actions/addProjectActions";
import { projectInfoResult, selectRequestSubTypesByName } from "../../../redux/actions/lenderRequestActions";
import { isProjectRole } from "../../../redux/actions/userAction";
import PhasePanel from "../../AddNewPhase/Pages/PhasePanel";
import StreetAddressModal from "../../AddNewPhase/Pages/StreetAddressModal";
import { getGoogleAddressFields } from "../../shared/services/SharedService";
import "../AddNewProject.css";
import DuplicateProjectModal from "../Modals/DuplicateProjectModal";
import { PROJECT_TYPES } from "../../shared/constants/ProjectTypes";

const useStyles = makeStyles(style => ({
  fontSize: {
      "& span:last-child": {
          fontWeight: 300
      }
  }
}));

const CondoProjectPage = ({
  incrementCounter
}) => {
  const [pageLoaded, setPageLoaded] = useState(false);

  const condoProjectInfo = isProjectRole() 
    ? useSelector(store => store.addProjectReducer.condoProjectInfo)
    : useSelector(store => store.lenderRequestReducer.projectInfo);
  const classes = useStyles()

  const [projectInfo, setprojectInfo] = React.useState(condoProjectInfo);
  const [showDuplicateModal, setShowDuplicateModal] = React.useState(false);
  const [duplicateData, setduplicateData] = React.useState([]);
  const [totalConveyPerc, setTotalConveyPerc] = React.useState(); 
  const [loading, setLoading] = React.useState(false);
  const [hasProjectAddressInfo, setHasProjectAddressInfo] = React.useState(false);
  const [showPhaseToggle, setShowPhaseToggle] = React.useState(false);
  const [showPhaseList, setShowPhaseList] = React.useState(false);
  const [phases, setPhases] = React.useState([]);
  const [phasesValid, setPhasesValid] = React.useState([]);
  const [showPhaseValidation, setShowPhaseValidation] = React.useState(false);

  // Street address modal state for phases
  const [showAddressModal, setShowAddressModal] = React.useState(false);
  const [activePhaseIndex, setActivePhaseIndex] = React.useState(null);

  const [errorPhaseName, seterrorPhaseName] = React.useState("");
  const [errorstreetAddress, seterrorstreetAddress] = React.useState("");
  const [errorunits, seterrorunits] = React.useState("");
  const [errorCity, seterrorCity] = React.useState("");
  const [errorState, seterrorState] = React.useState("");
  const [errorCoop, seterrorCoop] = React.useState("");
  const [errorManf, seterrorManf] = React.useState("");
  const [errorStatus, seterrorStatus] = React.useState("");
  const [errorZip5, seterrorZip5] = React.useState("");
  const [errorZipExt, seterrorZipExt] = React.useState("");
  const [errorStyleComment, seterrorStyleComment] = React.useState("");
  const [errorHoaTax, seterrorHoaTax] = React.useState("");
  const [errorConveyedUnits, setErrorConveyedUnits] = React.useState(""); 
  const [errorIsProjectComplete, setIsProjectComplete] = React.useState(""); 
  const [errorIsProjectSubjectToAddPhase, setIsProjectSubjectToAddPhase] = React.useState(""); 
  const [errorIsProjectHOATurnoverOwner, setIsProjectHOATurnoverOwner] = React.useState(""); 
  const [errorHasDeveloperOwnedUnits, setHasDeveloperOwnedUnits] = React.useState(""); 
  const [errorDeveloperOwnedUnits, setDeveloperOwnedUnits] = React.useState(""); 
  const [apiErr, setApiErr] = React.useState("");

  const hasDuplicate = async (isSubmitting) => {
    const { phaseName, zip5, streetAddress, state, city } = projectInfo;

    const duplicateCheckData = {
      condominiumProjectName: phaseName,
      userProvidedAddress: streetAddress,
      stateCode: state,
      postalCode: zip5,
      cityName: city
    };

    if(phaseName && streetAddress && zip5 && state && city){
      const result = await axios.post(
        global.REACT_APP_API_ENDPOINT +
        `/lender/request/checkDuplicates`,
        duplicateCheckData
      );

      if (result.data?.recordMatchCount) {
        console.log("Found possible duplicates:", result.data.matchedProjects);

        if (!result.data.matchedProjects?.length) {
          // should not be possible unless API returns bad data
          console.error("Exception: unexpected structure in result.data", result.data);
        }
        setduplicateData(result.data.matchedProjects);
        setIsSubmitting(isSubmitting);
        setShowDuplicateModal(true);
        return true;
      }

      return false;
    }   
  }

  useEffect(() => {
    const hasAddressInfo = projectInfo?.city && projectInfo?.state;
    setHasProjectAddressInfo(hasAddressInfo);
  }, [projectInfo?.city, projectInfo?.state]);

  useEffect(() => {
    // Note that phaseName only triggers the duplicate check on blur in case the user is still typing
    if (projectInfo?.phaseName && projectInfo?.streetAddress && projectInfo?.city && projectInfo?.state && projectInfo?.zip5) {
      hasDuplicate(false);
    }
  }, [projectInfo?.streetAddress, projectInfo?.city, projectInfo?.state, projectInfo?.zip5]);

  useEffect(() => {
    if (!isProjectRole() && condoProjectInfo) {
      const projectType = condoProjectInfo.type;
      const showPhaseList = projectType === PROJECT_TYPES.NEW_CONDO;
      
      if (showPhaseList) {
        const phases = condoProjectInfo.phases || [];
        setShowPhaseToggle(true);
        setShowPhaseList(phases.length > 0);
        setPhases(phases.map(phase => ({ ...phase })));
        setPhasesValid(phases.map(() => true)); // Assuming phases from store are valid, set all to true
      } else {
        setShowPhaseToggle(false);
        setShowPhaseList(false);
        setPhases([]);
        setPhasesValid([]);
      }
    }

    if (!pageLoaded) {
      setPageLoaded(true);
    }
  }, [condoProjectInfo]);

  const dispatch = useDispatch();
  React.useEffect(() => {
    initializeAutoComplete();

    if (projectInfo) {
      if (projectInfo.units >= 0) {
        const conveyPerc = calculatePercentage(projectInfo.conveyedUnits, projectInfo.units);
        setTotalConveyPerc(conveyPerc);
      }
    }
  }, [projectInfo]);

  // Create element references
  let phaseName = React.createRef();
  let zip5 = React.createRef();
  let zipExt = React.createRef();
  let units = React.createRef();
  let city = React.createRef();
  let style = React.createRef();
  let type = React.createRef();
  let State = React.createRef();
  let Coop = React.createRef();
  let Manf = React.createRef();
  let Status = React.createRef();
  let HOAtaxid = React.createRef();
  let conveyedUnits = React.createRef();
  let isProjectSubjectToAddPhase =  React.createRef();
  let isProjectHOATurnoverOwner =  React.createRef();
  let hasDeveloperOwnedUnits =  React.createRef();
  let developerOwnedUnits =  React.createRef();
  let isProjectComplete =  React.createRef();

  let streetAddressRef = useRef(null);

  const [isSubmitted, setIsSubmitted] = useState(false)
  const [commentLength, setCommentLength] = React.useState(0);
  const [styleLength, setStyleLength] = React.useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false)

  const state = useSelector(store => store.dialogueReducer.states);
  const styles = useSelector(store => store.styleReducer.styles);
  const types = useSelector(store => store.typeReducer.types);

  function handleChange(event) {    
    setprojectInfo(prev => ({ 
      ...prev, 
      [event.target.name]: event.target.value 
    }));
  }

  // if the project's city, state, or zip changes, update all phases
  useEffect(() => {
    if (!isProjectRole() && projectInfo && phases.length) {
      const updatedPhases = phases.map(phase => ({
        ...phase,
        street: phase.street || projectInfo.streetAddress,
        city: projectInfo.city,
        state: projectInfo.state,
        zip5: projectInfo.zip5
      }));
      setPhases(updatedPhases);
    }
  }, [projectInfo?.city, projectInfo?.state, projectInfo?.zip5, projectInfo?.streetAddress]);

  useEffect(() => {
    if (!isProjectRole() && projectInfo) {
      const projectType = projectInfo.type;

      if (projectType === PROJECT_TYPES.NEW_CONDO) {
        setShowPhaseToggle(true);
        if (phases.length > 0) {
          setShowPhaseList(true);
        }
      } else {
        setShowPhaseToggle(false);
        setShowPhaseList(false);
        setPhases([]);
        setPhasesValid([]);
      }
    }
  }, [projectInfo?.type]);

  useEffect(() => {
    if (!isProjectRole() && projectInfo && pageLoaded) {
      const _projectInfo = { ...projectInfo };
      const conveyPerc = calculatePercentage(_projectInfo.conveyedUnits, _projectInfo.units);

      const showHasDeveloperOwnedUnits =
        _projectInfo.isProjectComplete === "true" &&
        _projectInfo.isProjectSubjectToAddPhase === "false" &&
        _projectInfo.isProjectHOATurnoverOwner === "true" &&
        conveyPerc >= 80 && 
        conveyPerc < 90;

      // Clear value for hidden field
      if (!showHasDeveloperOwnedUnits) {
        _projectInfo.hasDeveloperOwnedUnits = undefined;
      }

      // Clear value for hidden field
      if (_projectInfo.hasDeveloperOwnedUnits !== "true") {
        _projectInfo.developerOwnedUnits = undefined;
      }

      // Calculate the project type
      if (showHasDeveloperOwnedUnits && !_projectInfo.hasDeveloperOwnedUnits) {
        _projectInfo.type = "";
      } else if (_projectInfo.hasDeveloperOwnedUnits === "true") {
        const developerOwnedPerc = calculatePercentage(_projectInfo.developerOwnedUnits, _projectInfo.units);

        if (developerOwnedPerc > 20) {
          _projectInfo.type = PROJECT_TYPES.NEW_CONDO;
        } else if (developerOwnedPerc > 0 && developerOwnedPerc <= 20) {
          _projectInfo.type = PROJECT_TYPES.ESTABLISHED_CONDO;
        } else {
          _projectInfo.type = "";
        }
      } else if (
        !_projectInfo.isProjectComplete || 
        !_projectInfo.isProjectSubjectToAddPhase || 
        !_projectInfo.isProjectHOATurnoverOwner || 
        !_projectInfo.units || 
        !_projectInfo.conveyedUnits ||
        !(conveyPerc > 0)
      ) {
        _projectInfo.type = "";
      } else if (
        conveyPerc < 90 || 
        _projectInfo.isProjectComplete === "false" || 
        _projectInfo.isProjectSubjectToAddPhase === "true" || 
        _projectInfo.isProjectHOATurnoverOwner === "true"
      ) {
        _projectInfo.type = PROJECT_TYPES.NEW_CONDO;
      } else {
        _projectInfo.type = PROJECT_TYPES.ESTABLISHED_CONDO;
      }

      setprojectInfo(_projectInfo);
    } 
  }, [
    pageLoaded,
    projectInfo?.isProjectComplete, 
    projectInfo?.isProjectSubjectToAddPhase, 
    projectInfo?.isProjectHOATurnoverOwner, 
    projectInfo?.units,
    projectInfo?.conveyedUnits,
    projectInfo?.hasDeveloperOwnedUnits,
    projectInfo?.developerOwnedUnits,
    totalConveyPerc
  ]);

  function handleWarningModalCancel(){
    setshowModal1(false)
  }

  function handleDuplicateModalCancel(){
    setLoading(false);
    setShowDuplicateModal(false)
  }

  function handleDuplicateModalContinue() {
    setShowDuplicateModal(false)
    createProjectOrRequest();
  }
  
  function lenderFieldValidations(){
    let hasError = false;

    if (conveyedUnits.current.value.length == 0) {
      setErrorConveyedUnits("This field is required");
      hasError = true;
    } else if (conveyedUnits.current.value <= 0) {
      setErrorConveyedUnits("Number of units cannot be 0 or negative");
      hasError = true;
    } else {
      setErrorConveyedUnits("");
    }

    if (isProjectComplete.current.value.length == 0) {
      setIsProjectComplete("This field is required");
      hasError = true;
    } else {
      setIsProjectComplete("");
    }

    if (isProjectSubjectToAddPhase.current.value.length == 0) {
      setIsProjectSubjectToAddPhase("This field is required");
      hasError = true;
    } else {
      setIsProjectSubjectToAddPhase("");
    }

    if (isProjectHOATurnoverOwner.current.value.length == 0) {
      setIsProjectHOATurnoverOwner("This field is required");
      hasError = true;
    } else {
      setIsProjectHOATurnoverOwner("");
    }

    if (
      projectInfo.isProjectComplete === "true" &&
      projectInfo.isProjectSubjectToAddPhase === "false" &&
      projectInfo.isProjectHOATurnoverOwner === "true" &&
      totalConveyPerc >= 80 && totalConveyPerc < 90
    ) {
        if (hasDeveloperOwnedUnits.current.value.length == 0) {
          setHasDeveloperOwnedUnits("This field is required");
          hasError = true;
        } else {
          setHasDeveloperOwnedUnits("");
          if (hasDeveloperOwnedUnits?.current?.value=== "true") {
            if (developerOwnedUnits?.current?.value?.length == 0) {
              setDeveloperOwnedUnits("This field is required");
              hasError = true;
            } else if (developerOwnedUnits?.current?.value <= 0) {
              setDeveloperOwnedUnits("Number of units cannot be 0 or negative");
              hasError = true;
            } else {
              setDeveloperOwnedUnits("");
            }
          }
        }
      }
      else {
          setHasDeveloperOwnedUnits("");
          setDeveloperOwnedUnits("");
        }

    return hasError;
  }

  // Returns the percentage, but only if both values are valid positive numbers
  function calculatePercentage(portion, total) {
    if (portion > 0 && total > 0) {
      const percentage = (portion / total) * 100;
      return percentage;
    }
  }

  function isInvalid() {
    let hasError = false;
    
    if (phaseName.current.value.length == 0) {
      seterrorPhaseName("This field is Required");
      hasError = true;
    } else {
      seterrorPhaseName("");
    }

    if (units.current.value.length == 0) {
      seterrorunits("This field is required");
      hasError = true;
    } else if (units.current.value <= 0) {
      seterrorunits("Number of units cannot be 0 or negative");
      hasError = true;
    } else {
      seterrorunits("");
    }

    if (streetAddressRef.current.value.length == 0) {
      seterrorstreetAddress("This field is required");
      hasError = true;
    } else {
      seterrorstreetAddress("");
    }

    const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);
    if (city.current.value.length == 0) {
      seterrorCity("This field is required");
      hasError = true;
    } else if (regex.test(city.current.value) === false) {
      seterrorCity("Invalid City");
      hasError = true;
    } else {
      seterrorCity("");
    }

    if (State.current.value.length == 0) {
      seterrorState("This field is required");
      hasError = true;
    } else {
      seterrorState("");
    }

    if (Coop.current.value.length == 0) {
      seterrorCoop("This field is required");
      hasError = true;
    } else {
      seterrorCoop("");
    }

    if (Manf.current.value.length == 0) {
      seterrorManf("This field is required");
      hasError = true;
    } else {
      seterrorManf("");
    }

    if (Status.current.value.length == 0) {
      seterrorStatus("This field is required");
      hasError = true;
    } else {
      seterrorStatus("");
    }

    const regexZip = new RegExp(/^[0-9]{5}$/);
    if (zip5.current.value.length == 0) {
      seterrorZip5("This field is required");
      hasError = true;
    } else if (regexZip.test(zip5.current.value) === false) {
      seterrorZip5("Invalid Zip Code");
      hasError = true;
    } else {
      seterrorZip5("");
    }

    const regexZipExt = new RegExp(/^[0-9]{4}$/);
    if (zipExt?.current?.value && regexZipExt.test(zipExt.current.value) === false) {
      seterrorZipExt("Invalid Zip Code");
      hasError = true;
    } else {
      seterrorZipExt("");
    }

    if (projectInfo.style == "Other" && projectInfo.styleComments == "") {
      seterrorStyleComment("This field is required");
      hasError = true;
    } else {
      seterrorStyleComment("");
    }

    if (HOAtaxid.current.value.length > 0) {
      if (HOAtaxid.current.value.length > 16) {
        seterrorHoaTax("Please enter less then 16 digits");
        hasError = true;
      } else if (!/[0-9]{2}-[0-9]{7}$/i.test(HOAtaxid.current.value)) {
        seterrorHoaTax("Invalid Tax ID. Format: XX-XXXXXXX");
        hasError = true;
      } else {
        seterrorHoaTax("");
      }
    }

    if (!isProjectRole()) {
      if (conveyedUnits.current.value.length == 0) {
        setErrorConveyedUnits("This field is required");
        hasError = true;
      } else if (conveyedUnits.current.value <= 0) {
        setErrorConveyedUnits("Number of units cannot be 0 or negative");
        hasError = true;
      } else {
        setErrorConveyedUnits("");
      }

      if (isProjectComplete.current.value.length == 0) {
        setIsProjectComplete("This field is required");
        hasError = true;
      } else {
        setIsProjectComplete("");
      }

      if (isProjectSubjectToAddPhase.current.value.length == 0) {
        setIsProjectSubjectToAddPhase("This field is required");
        hasError = true;
      } else {
        setIsProjectSubjectToAddPhase("");
      }

      if (isProjectHOATurnoverOwner.current.value.length == 0) {
        setIsProjectHOATurnoverOwner("This field is required");
        hasError = true;
      } else {
        setIsProjectHOATurnoverOwner("");
      }

      if (
        projectInfo.isProjectComplete === "true" &&
        projectInfo.isProjectSubjectToAddPhase === "false" &&
        projectInfo.isProjectHOATurnoverOwner === "true" &&
        totalConveyPerc >= 80 && totalConveyPerc < 90
      ) {
        if (hasDeveloperOwnedUnits.current.value.length == 0) {
          setHasDeveloperOwnedUnits("This field is required");
          hasError = true;
        } else {
          setHasDeveloperOwnedUnits("");
          if (hasDeveloperOwnedUnits?.current?.value=== "true") {
            if (developerOwnedUnits?.current?.value?.length == 0) {
              setDeveloperOwnedUnits("This field is required");
              hasError = true;
            } else if (developerOwnedUnits?.current?.value <= 0) {
              setDeveloperOwnedUnits("Number of units cannot be 0 or negative");
              hasError = true;
            } else {
              setDeveloperOwnedUnits("");
            }
          }
        }
      } else {
        setHasDeveloperOwnedUnits("");
        setDeveloperOwnedUnits("");
      }
    }
    
    hasError = hasInvalidPhases() || hasError;

    return hasError;
  }

  function hasInvalidPhases() {
    // console.log('validating phases', {phasesValid, phases})

    if (!phasesValid.every(Boolean) || phases.length !== phasesValid.length) {
      console.error('invalid phases found', {phasesValid, phases})
      return true;
    }
    return false;
  }

  async function calladdProject(e) {
    e.preventDefault();
    console.log('calladdProject - projectInfo: ', projectInfo)

    setApiErr("");
    setIsSubmitted(true);
    
    if (isInvalid()) {
      console.error('Validation errors exist, cannot submit');
      return;
    }

    setLoading(true);

    const duplicateCheck = await hasDuplicate(true);

    if (!duplicateCheck) {
      createProjectOrRequest();
    }
    
    setLoading(false);
  }

  // NOTE: Be sure validation and duplicate check always run before this function
  async function createProjectOrRequest() {
    setLoading(true);

    const _projectInfo = {
      ...projectInfo,
      phases: phases
    };
    
    console.log('createProjectOrRequest', _projectInfo);

    try {
      if (isProjectRole()) {
        if (_projectInfo.type?.length) {
          const response = await dispatch(
            addProject(_projectInfo, incrementCounter)
          );
  
          setLoading(false);
  
          if (response?.message) {
            if (response.message == 'Internal server error') {
              window.location.href = "/error-page";
            } else {
              setApiErr(response.message);
            }
          }
        } else {
          console.error("Project Type is not set in projectInfo", _projectInfo);
          setApiErr("Project Type is not set");
        }
      } else {
        setprojectInfo(_projectInfo);
        
        if (_projectInfo.type.length) {
          const requestSubType = _projectInfo.type === PROJECT_TYPES.NEW_CONDO && phases?.length
            ? "Lender Add Project and Phases"
            : _projectInfo.type === PROJECT_TYPES.NEW_CONDO
            ? "New Project"
            : "Established Project";

          console.groupCollapsed(`createProjectOrRequest: "${requestSubType}"`);
          console.log('projectType', _projectInfo.type);
          console.log('requestSubType', requestSubType);
          console.log('projectInfo', _projectInfo);
          console.groupEnd();

          dispatch(selectRequestSubTypesByName([requestSubType]));
          dispatch(projectInfoResult(_projectInfo));
  
          incrementCounter();
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      throw error;
    }
  }

  const getSelectedRole = () => {
    const role = window.sessionStorage.getItem("role")
    return role.toLowerCase().includes("lender") && projectInfo.type === PROJECT_TYPES.NEW_CONDO;
  }

  const updateAddressField = (place) => {
    const address = getGoogleAddressFields(place);

    setprojectInfo({ 
      ...projectInfo,
      streetAddress: address.street,
      city: address.city,
      state: address.state,
      zip5: address.zip
    });
  
    //Update the validations
    if (address.street.length > 0) { 
      seterrorstreetAddress("");
    }
    if (address.city.length > 0) {
      seterrorCity('');
    }
    if (address.state.length > 0) {
      seterrorState('');
    }
    if (address.zip.length > 0) {
      seterrorZip5('');
    }
  }

  function initializeAutoComplete() {
    if (streetAddressRef?.current) {
      const input = streetAddressRef.current;
      const autocomplete = new window.google.maps.places.Autocomplete(input, {
        componentRestrictions: { country: 'US' },
        fields: ["address_components"],
        types: ['address']
      });
  
      autocomplete?.addListener('place_changed', () => {
        const place = autocomplete?.getPlace();
        if (place) {
          updateAddressField(place);
        }
      });
    }
  }

  function createNewPhase() {
    return {
      phaseName: "",
      phaseType: "Legal",
      buildingNumber: "",
      unitNumber: "",
      unitsPerPhase: "",
      street: projectInfo?.streetAddress || "",
      city: projectInfo?.city || "",
      state: projectInfo?.state || "",
      zip5: projectInfo?.zip5 || "",
    };
  }

  function handlePushNewPhase() {
    setPhases([...phases, createNewPhase()]);
    setPhasesValid([...phasesValid, false]); // New phase starts as invalid
  }

  // Handle opening the street address modal for phases
  const handleStreetInputFocus = (phaseIndex) => {
    setActivePhaseIndex(phaseIndex);
    setShowAddressModal(true);
  };

  // Handle address selection from modal for phases
  const handleAddressSelect = (streetAddress, phaseIndex) => {
    if (streetAddress && phaseIndex !== null) {
      const updatedPhases = [...phases];
      updatedPhases[phaseIndex] = {
        ...updatedPhases[phaseIndex],
        street: streetAddress
      };
      setPhases(updatedPhases);

      // The PhasePanel will receive the updated phase prop and re-validate itself
    }
  };

  // Handle closing the modal
  const handleCloseAddressModal = () => {
    setShowAddressModal(false);
    setActivePhaseIndex(null);
  };

  return (
    <>
    <DuplicateProjectModal
      show={showDuplicateModal}
      handleCancel={handleDuplicateModalCancel}
      handleContinue={handleDuplicateModalContinue}
      duplicateProjectData={duplicateData}
      blocking={isSubmitting}
    />
    <Grid item xs={12}>
      <form id="addProjectForm">
        <Grid item xs={12}>
          <h1 style={{ justifyContent: "center" }}>
            {isProjectRole()
              ? 'Add New Project'
              : 'Request New Project'
            }
          </h1>
        </Grid>
        <Grid item xs={12} styles={{ marginTop: 20 }}>
          <h6 style={{ justifyContent: "center" }}>
            Step 1 of {isProjectRole() ? "2" : "3"} - New Project Details
          </h6>
        </Grid>
        <Grid item xs={12}>
            {
              isProjectRole() && <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    Select New Project Type<span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>

                  <RadioGroup ref={type} row aria-label="position" name="type" defaultValue=""
                    onChange={event => {
                      handleChange(event);
                    }}>
                    {types &&
                      types.length > 0 &&
                      types.filter((e, idx) => idx !== 0).map(item => {
                        return (
                          <FormControlLabel
                            className={classes.fontSize}
                            key={item.key}
                            style={{ fontWeight: "normal" }}
                            value={item.key}

                            control={<Radio color="primary" />}
                            label={item.value}
                            labelPlacement="end"
                          />
                        );
                      })}

                  </RadioGroup>
                </Grid>
                <Grid item xs={12} sm={12} md={10} style={{ margin: 0, paddingTop: "0px" }}>
                  {
                    !projectInfo.type.length && isSubmitted ?
                      <p style={{ color: "#f00" }}>Please select project type</p> :
                      null
                  }
                </Grid>
              </Grid>
            }

          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Project Legal Name<span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                autoFocus
                required
                type="text"
                className="form-control"
                name="phaseName"
                style={{ marginLeft: "0" }}
                value={projectInfo.phaseName}
                ref={phaseName}
                onChange={event => {
                  handleChange(event);

                  if (phaseName.current.value.length == 0) {
                    seterrorPhaseName("This field is required");
                  } else {
                    seterrorPhaseName("");
                  }
                }}
                onBlur={event => {
                  hasDuplicate(false)
                }}
              />
              {errorPhaseName != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorPhaseName}</p>
              ) : null}
            </Grid>
          </Grid>
          {/* <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>Legacy CPM ID</div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                type="text"
                className="form-control"
                name="cpmId"
                value={projectInfo.cpmId}
                maxLength="16"
                onChange={event => {
                  handleChange(event);
                }}
              />
            </Grid>
          </Grid> */}
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>Alternative Name</div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                type="text"
                className="form-control"
                name="alternativeName"
                value={projectInfo.alternativeName}
                onChange={event => {
                  handleChange(event);
                }}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Number of Known Units in Project
                <span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                required
                type="number"
                className="form-control"
                name="units"
                min="0"
                value={projectInfo.units}
                ref={units}
                onChange={event => {
                  handleChange(event);
                  if (units.current.value.length == 0) {
                    seterrorunits("This field is required");
                  } else if (units.current.value <= 0) {
                    seterrorunits("Number of units cannot be 0 or negative");
                  } else {
                    const conveyPerc = calculatePercentage(projectInfo.conveyedUnits, units.current.value);
                    setTotalConveyPerc(conveyPerc);
                    seterrorunits("");
                  }
                }}
              />
              {errorunits != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorunits}</p>
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Address<span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                ref={streetAddressRef}
                required
                type="text"
                className="form-control"
                name="streetAddress"
                placeholder=""
                value={projectInfo.streetAddress ?? ''}
                onChange={event => {
                  handleChange(event);
                  if (streetAddressRef.current.value.length == 0) {
                    seterrorstreetAddress("This field is required");
                  } else {
                    seterrorstreetAddress("");
                  }
                }}
              />
              {errorstreetAddress != "" ? (
                <p style={{ color: "red", margin: "0px" }}>
                  {errorstreetAddress}
                </p>
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                City<span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                required
                type="text"
                className="form-control"
                name="city"
                value={projectInfo.city}
                ref={city}
                onChange={event => {
                  handleChange(event);
                  const regex = new RegExp(/^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/);
                  if (city.current.value.length == 0) {
                    seterrorCity("This field is required");
                  } else if (regex.test(city.current.value) === false) {
                    seterrorCity("Invalid City");
                  } else {
                    seterrorCity("");
                  }
                }}
              />
              {errorCity != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorCity}</p>
              ) : null}
            </Grid>
          </Grid>

          <Grid container spacing={2} >
            <Grid item xs={12} sm={12} md={6}>
              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    State<span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <select
                    required
                    name="state"
                    id={"state"}
                    className="form-control"
                    ref={State}
                    value={projectInfo.state}
                    onChange={event => {
                      handleChange(event);
                      if (State.current.value.length == 0) {
                        seterrorState("Please Select a State");
                      } else {
                        seterrorState("");
                      }
                    }}
                  >
                    {state &&
                      state.length > 0 &&
                      state.map(item => {
                        return (
                          <option key={item.key} value={item.key}>
                            {item.value}
                          </option>
                        );
                      })}
                  </select>
                  {errorState != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>{errorState}</p>
                  ) : null}
                </Grid>
              </Grid>          
            </Grid>

            <Grid item xs={12} sm={12} md={4}>
              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    Zip<span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={7} sm={7} md={7}>
                  <input
                    required
                    type="text"
                    className="form-control"
                    name="zip5"
                    value={projectInfo.zip5}
                    ref={zip5}
                    maxLength="5"
                    onChange={event => {
                      handleChange(event);
                      const regexZip = new RegExp(/^[0-9]{5}$/);
                      if (zip5.current.value.length == 0) {
                        seterrorZip5("This field is required");
                      } else if (regexZip.test(zip5.current.value) === false) {
                        seterrorZip5("Invalid Zip Code");
                      } else {
                        seterrorZip5("");
                      }
                    }}
                  />
                  {errorZip5 != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>{errorZip5}</p>
                  ) : null}
                </Grid>
                {isProjectRole() ? (
                  <>
                    <Grid item xs={5} sm={5} md={5}>
                      <input
                        type="text"
                        className="form-control"
                        name="zip"
                        value={projectInfo.zip}
                        ref={zipExt}
                        size="4"
                        maxLength="4"
                        onChange={event => {
                          handleChange(event);
                          const regexZip = new RegExp(/^[0-9]{4}$/);
                          if (zipExt.current.value.length) {
                            if (regexZip.test(zipExt.current.value) === false) {
                              seterrorZipExt("Invalid Zip");
                            } else {
                              seterrorZipExt("");
                            }
                          }
                        }}
                      />
                      {errorZipExt != "" ? (
                        <p style={{ color: "red", margin: "0px" }}>{errorZipExt}</p>
                      ) : null}
                    </Grid>
                  </>
                ) : null}
              </Grid>            
            </Grid>       
          </Grid>

          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Style
                {/* <span style={{ color: "red" }}>*</span> */}
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <select
                required
                name="style"
                id={"style"}
                className="form-control"
                ref={style}
                value={projectInfo.style}
                onChange={event => {
                  handleChange(event);
                }}
              >
                {styles &&
                  styles.length > 0 &&
                  styles.map(item => {
                    return (
                      <option key={item.key} value={item.key}>
                        {item.value}
                      </option>
                    );
                  })}
              </select>

              {projectInfo.style == "Other" ? (
                <div>
                  <textarea
                    rows="3"
                    type="text"
                    className="form-control mt-3"
                    name="styleComments"
                    required
                    maxLength="200"
                    placeholder="Enter your Style*"
                    onChange={event => {
                      setprojectInfo({
                        ...projectInfo,
                        styleComments: event.target.value
                      });
                      setStyleLength(event.target.value.length);
                    }}
                  ></textarea>
                  <span
                    style={{
                      display: "inline-block",
                      marginRight: "5px",
                      float: "right",
                      fontSize: "14px",
                      color: "#787979"
                    }}
                  >{`${styleLength}/200`}</span>
                  {errorStyleComment != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>
                      {errorStyleComment}
                    </p>
                  ) : null}
                </div>
              ) : null}
            </Grid>
          </Grid>

         
          <Grid container spacing={2} className="dialoguClass" 
           style={{display: getSelectedRole() ? "none":"block"}}>
            <Grid item xs={12} sm={12} md={12}>
              <div>HOA Tax ID</div>
            </Grid>

            <Grid item xs={12} sm={12} md={10}>
              <input
                className="form-control"
                name="HOAtaxid"
                ref={HOAtaxid}
                maxLength={16}
                value={projectInfo.HOAtaxid}
                onChange={handleChange}
              />

              {errorHoaTax != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorHoaTax}</p>
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>Home Owner's Association Name</div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                className="form-control"
                name="HOAname"
                value={projectInfo.HOAname}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>Master Association Name</div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <input
                className="form-control"
                name="MAname"
                value={projectInfo.MAname}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Is the project a cooperative?<span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <select
                required
                name="coopInd"
                id={"coopInd"}
                className="form-control"
                ref={Coop}
                value={projectInfo.coopInd}
                onChange={event => {
                  handleChange(event);
                  if (Coop.current.value.length == 0) {
                    seterrorCoop("Please Select Yes or No");
                  } else {
                    seterrorCoop("");
                  }
                }}
              >         
                <option value="">Select Yes or No</option>
                <option value="true">Yes</option>
                <option value="false">No</option>                      
              </select>
              {errorCoop != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorCoop}</p>
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Does the project consist of manufactured housing?<span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <select
                required
                name="manfdHousngInd"
                id={"manfdHousngInd"}
                className="form-control"
                ref={Manf}
                value={projectInfo.manfdHousngInd}
                onChange={event => {
                  handleChange(event);
                  if (Manf.current.value.length == 0) {
                    seterrorManf("Please Select Yes or No");
                  } else {
                    seterrorManf("");
                  }
                }}
              >         
                <option value="">Select Yes or No</option>
                <option value="true">Yes</option>
                <option value="false">No</option>                      
              </select>
              {errorManf != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorManf}</p>
              ) : null}
            </Grid>
          </Grid>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>
                Does the project consist of attached units?<span style={{ color: "red" }}>*</span>
              </div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <select
                required
                name="unitsType"
                id={"unitsType"}
                className="form-control"
                ref={Status}
                value={projectInfo.unitsType}
                onChange={event => {
                  handleChange(event);
                  if (Status.current.value.length == 0) {
                    seterrorStatus("Please Select a Unit Type");
                  } else {
                    seterrorStatus("");
                  }
                }}
              >         
                <option value="">Select a Unit Type</option>
                <option value="Attached">Attached</option>
                <option value="Detached">Detached</option> 
                <option value="Combination">Combination</option>                      
              </select>
              {errorStatus != "" ? (
                <p style={{ color: "red", margin: "0px" }}>{errorStatus}</p>
              ) : null}
            </Grid>
          </Grid>

          {!isProjectRole() &&
            <>
              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={10}>
                  <div>
                    How many units are conveyed? (Ownership of conveyed units has been legally transferred from the developer (or current owner) to individual buyers.)
                    <span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>
                  <input
                    required
                    type="number"
                    className="form-control"
                    name="conveyedUnits"
                    min="0"
                    value={projectInfo.conveyedUnits}
                    ref={conveyedUnits}
                    onChange={event => {
                      handleChange(event);
                      if (conveyedUnits.current.value.length == 0) {
                        setErrorConveyedUnits("This field is required");
                      } else if (conveyedUnits.current.value <= 0) {
                        setErrorConveyedUnits("Number of conveyed units cannot be 0 or negative");
                      } else {
                        setErrorConveyedUnits("");
                        const conveyPerc = calculatePercentage(conveyedUnits.current.value, units.current.value);
                        setTotalConveyPerc(conveyPerc);
                      }
                    }}
                  />
                  {errorConveyedUnits != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>{errorConveyedUnits}</p>
                  ) : null}
                </Grid>
              </Grid>

              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    Is the project 100% complete ?<span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>
                  <select
                    required
                    name="isProjectComplete"
                    id={"isProjectComplete"}
                    className="form-control"
                    ref={isProjectComplete}
                    value={projectInfo.isProjectComplete}
                    onChange={event => {
                      handleChange(event);
                      if (isProjectComplete.current.value.length == 0) {
                        setIsProjectComplete("Please Select Yes or No");
                      } else {
                        setIsProjectComplete("");
                      }
                    }}
                  >
                    <option value="">Select Yes or No</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  {errorIsProjectComplete != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>{errorIsProjectComplete}</p>
                  ) : null}
                </Grid>
              </Grid>

              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    Is the project subject to additional phase or annexation ?<span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>
                  <select
                    required
                    name="isProjectSubjectToAddPhase"
                    id={"isProjectSubjectToAddPhase"}
                    className="form-control"
                    ref={isProjectSubjectToAddPhase}
                    value={projectInfo.isProjectSubjectToAddPhase}
                    onChange={event => {
                      handleChange(event);
                      if (isProjectSubjectToAddPhase.current.value.length == 0) {
                        setIsProjectSubjectToAddPhase("Please Select Yes or No");
                      } else {
                        setIsProjectSubjectToAddPhase("");
                      }
                    }}
                  >
                    <option value="">Select Yes or No</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  {errorIsProjectSubjectToAddPhase != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>{errorIsProjectSubjectToAddPhase}</p>
                  ) : null}
                </Grid>
              </Grid>

              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    Is the Developer still in control of the HOA?<span style={{ color: "red" }}>*</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>
                  <select
                    required
                    name="isProjectHOATurnoverOwner"
                    id={"isProjectHOATurnoverOwner"}
                    className="form-control"
                    ref={isProjectHOATurnoverOwner}
                    value={projectInfo.isProjectHOATurnoverOwner}
                    onChange={event => {
                      handleChange(event);
                      if (isProjectHOATurnoverOwner.current.value.length == 0) {
                        setIsProjectHOATurnoverOwner("Please Select Yes or No");
                      } else {
                        setIsProjectHOATurnoverOwner("");
                      }
                    }}
                  >
                    <option value="">Select Yes or No</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                  {errorIsProjectHOATurnoverOwner != "" ? (
                    <p style={{ color: "red", margin: "0px" }}>{errorIsProjectHOATurnoverOwner}</p>
                  ) : null}
                </Grid>
              </Grid>

              {
                (() => {
                  return (
                    projectInfo.isProjectComplete === "true" &&
                    projectInfo.isProjectSubjectToAddPhase === "false" &&
                    projectInfo.isProjectHOATurnoverOwner === "true" &&
                    ( totalConveyPerc >= 80 && totalConveyPerc < 90 )
                  );
                })() ?
                (<>
                <Grid container spacing={2} className="dialoguClass">
                    <Grid item xs={12} sm={12} md={12}>
                      <div>
                        Are there developer-owned units that meet the rental hold-back requirements as defined in the Selling Guide ?<span style={{ color: "red" }}>*</span>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={10}>
                      <select
                        required
                        name="hasDeveloperOwnedUnits"
                        id={"hasDeveloperOwnedUnits"}
                        className="form-control"
                        ref={hasDeveloperOwnedUnits}
                        value={projectInfo.hasDeveloperOwnedUnits}
                        onChange={event => {
                          handleChange(event);
                          if (hasDeveloperOwnedUnits.current.value.length == 0) {
                            setHasDeveloperOwnedUnits("Please Select Yes or No");
                          } else {
                            setHasDeveloperOwnedUnits("");
                            
                            // If user selects "No", still show phase toggle for NEW Type (80-90% range)
                            if (hasDeveloperOwnedUnits.current.value === "false") {
                              setShowPhaseToggle(true); // Show phases for NEW Type
                            }
                          }
                        }}
                      >
                        <option value="">Select Yes or No</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                      {errorHasDeveloperOwnedUnits != "" ? (
                        <p style={{ color: "red", margin: "0px" }}>{errorHasDeveloperOwnedUnits}</p>
                      ) : null}
                    </Grid>
                  </Grid>
                  {
                    projectInfo.hasDeveloperOwnedUnits === "true" ?(
                      <Grid container spacing={2} className="dialoguClass" >
                      <Grid item xs={12} sm={12} md={12}>
                        <div>
                          How many developer-owned units are held? 
                          <span style={{ color: "red" }}>*</span>
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={12} md={10}>
                        <input
                          required
                          type="number"
                          className="form-control"
                          name="developerOwnedUnits"
                          min="0"
                          value={projectInfo.developerOwnedUnits}
                          ref={developerOwnedUnits}
                          onChange={event => {
                            handleChange(event);
                            if (developerOwnedUnits.current.value.length == 0) {
                              setDeveloperOwnedUnits("This field is required");
                            } else if (developerOwnedUnits.current.value <= 0) {
                              setDeveloperOwnedUnits("Number of conveyed units cannot be 0 or negative");
                            } else {
                              setDeveloperOwnedUnits("");
                            }
                          }}
                        />
                        {errorDeveloperOwnedUnits != "" ? (
                          <p style={{ color: "red", margin: "0px" }}>{errorDeveloperOwnedUnits}</p>
                        ) : null}
                      </Grid>
                    </Grid>
                    ): <></>
                  }
                </>) : <></>
              }
            </>
          }

          {!isProjectRole() && showPhaseToggle && hasProjectAddressInfo ? (
            <>
              <Grid container spacing={2} className="dialoguClass">
                <Grid item xs={12} sm={12} md={12}>
                  <div>
                    Do you need to add phases?
                  </div>
                </Grid>
                <Grid item xs={12} sm={12} md={10}>
                  <RadioGroup ref={type} row aria-label="position" name="type" defaultValue={showPhaseList ? "true" : "false"}
                      onChange={event => {
                        const showPhases = event.target.value === "true";
                        setShowPhaseList(showPhases);

                        if (showPhases) {
                          if (!phases.length) {
                            phases.push(createNewPhase());
                            setPhases([...phases]);
                          }
                        } else {
                          setPhases([]);
                          setPhasesValid([]);
                        }
                      }} >
                    <FormControlLabel
                      className={classes.fontSize}
                      style={{ fontWeight: "normal" }}
                      value="true"
                      control={<Radio color="primary" />}
                      label="Yes"
                      labelPlacement="end"
                    />
                    <FormControlLabel
                      className={classes.fontSize}
                      style={{ fontWeight: "normal" }}
                      value="false"
                      control={<Radio color="primary" />}
                      label="No"
                      labelPlacement="end"
                    />
                  </RadioGroup>
                </Grid>
              </Grid>

              {showPhaseList ? (            
                <Grid container spacing={2}>
                  <Grid item xs={12} sm ={12} md={11}>
                    <div className="phase-list">
                      {phases.map((phase, index) => (
                        <PhasePanel
                          key={index}
                          phase={phase}
                          phaseIndex={index}
                          canDelete={!!index}
                          forceValidation={isSubmitted || showPhaseValidation}
                          onStreetInputFocus={() => handleStreetInputFocus(index)}
                          onChange={(updatedPhase, isValid) => {
                            // Update the phase in the local state using immutable update
                            const updatedPhases = [...phases];
                            updatedPhases[index] = updatedPhase;
                            setPhases(updatedPhases);

                            // Update validation state using immutable update
                            const updatedPhasesValid = [...phasesValid];
                            updatedPhasesValid[index] = isValid;
                            setPhasesValid(updatedPhasesValid);
                          }}
                          onDelete={() => {
                            const updatedPhases = phases.filter((_, i) => i !== index);
                            const updatedPhasesValid = phasesValid.filter((_, i) => i !== index);
                            setPhases(updatedPhases);                        
                            setPhasesValid(updatedPhasesValid);
                          }}
                        />
                      ))} 

                      <Grid container spacing={0} className="dialoguClass">
                        <Grid item xs={11} sm ={11} md={11}>
                          <Grid container style={{justifyContent: "flex-end"}}>
                            <Button
                              type="link"
                              className="add-phase-button"
                              onSubmit={e => { 
                                e.preventDefault(); 
                                handlePushNewPhase();
                              }}
                              onClick={e => { 
                                e.preventDefault(); 
                                handlePushNewPhase();
                              }}
                              form="addProjectForm"
                            >
                              <AddCircleOutline />
                              <span>Add Another Phase</span>
                            </Button>            
                          </Grid>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </Grid>
              ) : <></>}
            </>
          ) : <></>}

          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm={12} md={12}>
              <div>Comments</div>
            </Grid>
            <Grid item xs={12} sm={12} md={10}>
              <div>
                <textarea
                  rows="3"
                  type="text"
                  className="form-control mt-3"
                  name="comments"
                  maxLength="5000"
                  placeholder="Enter your Comments"
                  value={projectInfo.comments}
                  onChange={e => {
                    handleChange(e);
                    setCommentLength(e.target.value.length);
                  }}
                ></textarea>
                <span
                  style={{
                    display: "inline-block",
                    marginRight: "5px",
                    float: "right",
                    fontSize: "14px",
                    color: "#787979"
                  }}
                >{`${commentLength}/5000`}</span>
              </div>
            </Grid>
          </Grid>
          <div
            style={{
              color: "#ff0000"
            }}
          >
            {apiErr ? apiErr : null}
          </div>
          <Grid container spacing={2} className="dialoguClass">
            <Grid item xs={12} sm ={12} md={10}>
              <Grid container justifyContent="flex-end">
                <Button
                  type="submit"
                  className={"btn-submit" + 
                    // (!isValid ? " btn-invalid" : "") +
                    (loading ? " btn-loading disabled" : "")
                  }
                  disabled={loading}
                  onSubmit={e => calladdProject(e)}
                  onClick={e => calladdProject(e)}
                  form="addProjectForm"
                >
                  {loading ? (
                    <CircularProgress
                      style={{
                        display: "inline-flex",
                        padding: "10px",
                        color: "#fff",
                        justifySelf: "center",
                        alignSelf: "center"
                      }}
                    />
                  ) : isProjectRole() ? "Save Project" : "Next"}
                </Button>            
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </Grid>

    {/* Street Address Selection Modal for Phase Panels */}
    <StreetAddressModal
      show={showAddressModal}
      onHide={handleCloseAddressModal}
      onAddressSelect={handleAddressSelect}
      phaseCity={(phases[activePhaseIndex] || projectInfo)?.city}
      phaseState={(phases[activePhaseIndex] || projectInfo)?.state}
      phaseZip={(phases[activePhaseIndex] || projectInfo)?.zip5}
      phaseStreet={(phases[activePhaseIndex] || projectInfo)?.street}
      phaseIndex={activePhaseIndex}
    />
    </>
  );
};

export default CondoProjectPage;